
import React from 'react';
import { useGroupOwner } from '@/hooks/use-group-owner';

interface VipBadgeProps {
  userId?: number;
  username?: string;
  isGroupOwner?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  variant?: 'icon-only' | 'with-text';
}

export const VipBadge: React.FC<VipBadgeProps> = React.memo(({
  userId,
  username,
  isGroupOwner = false,
  size = 'md',
  className = '',
  variant = 'with-text'
}) => {
  // Only call the hook if we have a valid userId and isGroupOwner is not already true
  const shouldFetchStatus = !isGroupOwner && userId && userId > 0;
  const { data: groupOwnerInfo, isLoading, error } = useGroupOwner(shouldFetchStatus ? userId : 0);

  // Use either the passed prop or the hook data
  const showBadge = isGroupOwner || (groupOwnerInfo?.isGroupOwner === true);

  const sizeClasses = {
    sm: 'w-2 h-2',
    md: 'w-3 h-3', 
    lg: 'w-4 h-4'
  };

  // Show icon only or username + icon based on variant
  if (variant === 'icon-only') {
    // Icon only: show badge icon if group owner, otherwise nothing
    if (!showBadge) {
      return null;
    }
    return (
      <img 
        src="/assets/images/vip2.svg" 
        alt="Group Owner"
        className={`inline-block rounded-full ${sizeClasses[size]} flex-shrink-0 ${className}`}
        title={username ? `${username} - Proprietario di gruppo` : "Proprietario di gruppo"}
      />
    );
  }

  // Default: show username always, add icon only if group owner
  return (
    <div className={`flex items-center gap-1 min-w-0 ${className}`}>
      <span className="font-medium tg-text truncate max-w-full capitalize">{username}</span>
      {showBadge && (
        <img 
          src="/assets/images/vip2.svg" 
          alt="Group Owner"
          className={`inline-block rounded-full ${sizeClasses[size]} flex-shrink-0`}
          title="Proprietario di gruppo"
        />
      )}
    </div>
  );
});

VipBadge.displayName = 'VipBadge';

export default VipBadge;
